<template>
    <div class="modalBG">
        <div class="modalContent">
            <h4 class="modalHeader">{{ header }}</h4>
            <div class="modalBody">
                <p>{{ text }}</p>
            </div>
            <div class="modalButtons">
                <button @click="confirm">확인</button>
                <button @click="cancel" class="cancel">취소</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        header: {
            type: String,
            default: '확인',
        },
        text: {
            type: String,
            default: '내용 없음',
        },
        resolve: {
            type: Function,
            required: true,
        },
    },
    methods: {
        confirm() {
            this.resolve(true);
            this.$el.remove(); // DOM에서 제거
        },
        cancel() {
            this.resolve(false);
            this.$el.remove(); // DOM에서 제거
        },
    },
};
</script>

<style scoped>
* {
    margin: 0;
}
.modalBG {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
.modalContent {
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    width: 300px;
    overflow: hidden;
}
.modalHeader {
    font-size: 14px;
    background-color: #1f3559;
    color: #fff;
    padding: 8px;
    font-weight: 500;
}
.modalBody {
    padding: 20px;
    text-align: center;
    font-size: 14px;
}
.modalButtons {
    display: flex;
    gap: 8px;
    justify-content: center;
    margin-bottom: 16px;
}
.modalButtons > button {
    all: unset;
    padding: 8px 24px;
    background: #42587e;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    font-weight: 400;
}
.modalButtons > button.cancel {
    background: #ddd;
    color: #000;
}
</style>
